<template>
  <Sheet :open="isOpen" @update:open="handleOpenChange">
    <EmailSheetContent
      v-if="emailStore.selectedContact"
      :contact-id="emailStore.selectedContact.contactId"
      :contact-email="emailStore.selectedContact.contactEmail"
      :contact-name="emailStore.selectedContact.contactName"
      @reload="emailStore.closeEmail"
    />
  </Sheet>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Sheet } from '@/components/ui/sheet';
import EmailSheetContent from './EmailSheetContent.vue';
import { useMultiEmailStore } from './useMultiEmailStore';

const emailStore = useMultiEmailStore();

const isOpen = computed(() => emailStore.selectedContact !== null);

const handleOpenChange = (open: boolean): void => {
  if (!open) emailStore.closeEmail();
};
</script>
